import { PopulationBasedFundingStatus } from "@/Common/Models/UI/Enums";

class PopulationBasedFundingPortfolioFilterSettings {
    public IncludedSites: string[] = [];
    public IncludedEmployeeContactFacetIds: string[] = [];
    public IncludedStatuses: PopulationBasedFundingStatus[] = [];
    public ShowEntriesWithNoAssignedPhysician: boolean = false;
    public ClinicianSearchText: string = "";

    public QueryPageSize: number = 50;

    public SearchText: string = "";
    public QueryCurrentPageNumber: number = 1;
    public QueryPageCount: number = 0;
    public QueryRowCount: number = 0;
}

export { PopulationBasedFundingPortfolioFilterSettings };
